import $ from 'jquery';
import 'what-input';

// Foundation JS relies on a global variable. In ES6, all imports are hoisted
// to the top of the file so if we used `import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;
require('foundation-sites');

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';
import 'slick-carousel/slick/slick';
import 'hc-sticky/dist/hc-sticky';
import 'lazysizes';
import 'waypoints/lib/noframework.waypoints';
import slidebars from "exports-loader?slidebars!Slidebars/dist/slidebars.js";
import 'slick-animation';  
// import './vendor/intlTelInput.gn'; 
// import './vendor/utils';


$(document).foundation();

$(document).ready(function () {

    $(".search-trigger").on("click", function (ev) {
        ev.preventDefault();
        $(".search-overlay").show();
    });

    $(".search-overlay-close-button a").on("click", function (ev) {
        ev.preventDefault();
        $(".search-overlay").hide();
    });

    
    var slideshow = $('.slideshow_js');
        slideshow.slick({
            // lazyLoad: 'ondemand',
            rtl: true,
            rows: 0,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
            fade: true,
            adaptiveHeight: true,
            mobileFirst: true,
            appendDots: $('.slick-slider-dots')
        });

        
    var slider = $('.slider');
        slider.slick({
            // lazyLoad: 'ondemand',
            rtl: true, 
            slidesToShow: 6,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            responsive: [
                {
                    breakpoint: 641,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
    
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                }
            ]
        });

    var stickyHeader = new hcSticky('#sticky-header', {
        stickTo: '#main-wrap',
        onStart: function () {
            $('.canvas-panel').css('top', $('.main-header-inner').outerHeight());
        },
        onStop: function () {
            $('.canvas-panel').css('top', $('#main-header').outerHeight());
        }
    });


    // Initialize Slidebars
    var controller = new slidebars();
    controller.init();

    $(document).on('click', '.toggle-nav-panel', function (event) {
        // Stop default action and bubbling
        event.stopPropagation();
        event.preventDefault();

        $('.toggle-nav-panel i').toggleClass('icon-menu icon-close');
       // $('.more-menu').toggleClass('opened-panel');
        //console.log("panel");
        // Toggle the Slidebar with id 'id-4'
        controller.toggle('nav-panel'); 
    });

    // Add close class to canvas container when Slidebar is opening
    var maxHeight;
    $(controller.events).on('opening', function (event) {
        $('[canvas="container"]').addClass('sb-opening');
        /*if ($('.stuck-header').length > 0) {
         $('.canvas-panel, .filter-panel-holder').css({"top": stickyHeader.height()});
         } else {
         $('.canvas-panel, .filter-panel-holder').css({"top": AreaToStick.height()});
         }*/
    });

    // Add close class to canvas container when Slidebar is opening
    $(controller.events).on('opened', function (event) {
        $('[canvas="container"]').addClass('sb-opened');
    });

    // Remove close class from canvas container when Slidebar is closing
    $(controller.events).on('closing', function (event) {
        $('[canvas="container"]').removeClass('sb-opening');
    });

    // Remove close class from canvas container when Slidebar is closing
    $(controller.events).on('closed', function (event) {
        $('[canvas="container"]').removeClass('sb-opened');
    });

     // Close any
     $(document).on('click', '.close-panel span, .more-menu.opened-panel', function (event) { //.sb-opening
        if (controller.getActiveSlidebar()) {
         event.preventDefault();
         event.stopPropagation();
         controller.close();
         }
        // $('.toggle-nav-panel').click()
    });

    // SORT CHAPTER 

    $(".sort_js").on('click', function(){
        
        if($(this).hasClass('sorted')){
             

            $('.chapters-list .chapter-list').sort(function(a, b) {
                return $(a).data('order') - $(b).data('order');
            }).appendTo('.chapters-list');
            $(this).removeClass('sorted');
        }
        else {
            
            $('.chapters-list .chapter-list').sort(function(a, b) {
                return $(b).data('order') - $(a).data('order');
            }).appendTo('.chapters-list');
            $(this).addClass('sorted');
        }
        
    })


    // EN ------------=====================

    var mainSlideshow = $('.mainSlide_js');
    mainSlideshow.slick({
         lazyLoad: 'progressive',
        rtl: true,
        rows: 0,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        fade: true, 
    }).slickAnimation();
 

     if($(".front").length > 0){
        changeSlide(); 
        mainSlideshow.on('afterChange', changeSlide);
     }
     
    
   // $('.morphnimate').removeClass("morph");

    function changeSlide(){
        const current = $('.gallery__slider .slick-current');
        var currentSlide = $('.mainSlide_js').slick('slickCurrentSlide') + 1;

        $('.morphnimate').removeClass("morph"); 
        $('.slideshow-item.slick-active.slick-current .morphnimate').addClass("morph");  
        
      };


    // Download APP

    if($(".downloadApp_js").length > 0){ 
        var downloadApp = $(".downloadApp_js");

        getMobileOperatingSystem();
        //console.log(getMobileOperatingSystem());

        function getMobileOperatingSystem() {
            var userAgent = navigator.userAgent || navigator.vendor || window.opera;

            // Windows Phone must come first because its UA also contains "Android"
            if (/windows phone/i.test(userAgent)) {     
                console.log('windows'); 
                $(downloadApp).attr("href", "https://play.google.com/store/apps/details?id=jp.co.shueisha.mangaplus");
            }

            if (/android/i.test(userAgent)) { 
                console.log('android');
                $(downloadApp).attr("href", "https://play.google.com/store/apps/details?id=jp.co.shueisha.mangaplus");
            }

            // iOS detection from: http://stackoverflow.com/a/9039885/177710
            if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) { 
                console.log('ios');
                $(downloadApp).attr("href", "https://apps.apple.com/app/id1442476536");
            }

            if (/(Mac|iPhone|iPod|iPad)/i.test(navigator.platform)){
                $(downloadApp).attr("href", "https://apps.apple.com/app/id1442476536");
            }else{ 
                $(downloadApp).attr("href", "https://play.google.com/store/apps/details?id=jp.co.shueisha.mangaplus");
            } 
    
        }
    }

    // PHONE W FLAG
    if($("#phone").length > 0){ 
        var input = document.querySelector("#phone");
        window.intlTelInput(input, { 
            separateDialCode: true,
            preferredCountries: ["sa"]
        });
    }
    
    //fileupload change

    $('.file-upload').on('change', function() {
        var filepath = this.value;
        var m = filepath.match(/([^\/\\]+)$/);
        var filename = m[1]; 
        $(this).closest('div').find('.filename').html(filename); 
    
    });
 
    // slider video

    if($(".slider-video_js").length > 0){ 
        var sliderVideo = $('.slider-video_js');
        sliderVideo.slick({
            // lazyLoad: 'ondemand',
            rtl: true, 
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
            responsive: [
                {
                    breakpoint: 641,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1

                    }
                },
                {
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }

    if($(".landing-v2").length > 0){ 
        $(document).on('click', 'a[href^="#"]', function (event) {
            event.preventDefault();
        
            $('html, body').animate({
                scrollTop: $($.attr(this, 'href')).offset().top - $("#sticky-header").height()
            }, 500);
        });
    }

    // CALENDAR EVENTS
if ($('#calendarEvents').length > 0) {
    var calendarEventsURL = "",
        tid = 'events',
        activeDay = $(".tabs-slider_js li.is-active").data("day"),
        activeMonth = $(".tabs-slider_js li.is-active").data("month"),
        today = new Date(),
        todayMonth = today.getMonth() + 1,
        todayDay = today.getDate();
      
        //console.log(todayDay, 'todayDay'); 
        //console.log(todayMonth, 'month today');
  
         
    var ar = moment().locale('ar');
      
    const month =  [moment('2021-10-01', 'YYYY-MM-DD'), moment('2021-12-30', 'YYYY-MM-DD')];
    const range = moment().range(month); 
    const days = range.by('days');  
  
  
    var localMonth = moment().locale('ar');
    //console.log(localMonth.format('MMMM'), 'local');
  
   var daysOfMonth  = [...days].map(function(date){
       //date => date.format('DD')
       var d = date.format('DD');
       var m = date.format('MMMM');
       var mm = date.format('MM');  
       var yr = date.format('YYYY');  
       var days = ar.localeData().weekdays(date);
       var monthAr = ar.localeData().months(date);
   
       $(".tabs-slider_js").append('<li class="events-date-items_js  events-date-items" data-day="'+ d +'" data-month="'+ mm +'"><a href="#panel'+d+''+mm+'v"> ' +days+  + d + ' ' + monthAr + ' '+yr+' </a></li>'); 
       $(".event-tabs-content_js").append('<div class="tabs-panel events-slick-item_js"  data-day="'+ d +'" data-month="'+ mm +'" id="panel'+d+''+mm+'vv"><div class="events-item_js">' +
            '<div class="ajax-loader text-center">' +
                '<img src="assets/img/ajax-loader.gif"/>' +
            '</div>' +
            '</div> </div> ')
   }); 
    
      
    setTimeout(function(){  
  
        var slickIndex = $('.events-date-items_js[data-day="'+todayDay+'"][data-month="'+todayMonth+'"]').closest(".slick-slide").attr('data-slick-index');
        $('.tabs-slider_js').slick('slickGoTo', slickIndex); 
  
        var slickItemIndex =  $('.events-slick-item_js[data-day="'+todayDay+'"][data-month="'+todayMonth+'"]').closest(".slick-slide").attr('data-slick-index');
        $('.event-tabs-content_js').slick('slickGoTo', slickItemIndex); 
    }, 1000);
  
      
    //console.log(todayDay, todayMonth, 'todayDay, todayMonth');
    function loadData(thisDay, thisMonth){
  
        if (location.hostname === "localhost" || location.hostname === "127.0.0.1") {
           // calendarEventsURL = "assets/json/events-" + thisDay + "-" + thisMonth + ".json"; 
        } else { 
           // calendarEventsURL = "https://" + thisDay + "/" + thisMonth + "";
        }
  
        calendarEventsURL =  "assets/json/events-" + thisDay + "-" + thisMonth + ".json"; 

        console.log(calendarEventsURL, 'calendar');
        $.ajax({
            url: calendarEventsURL,
            dataType: "json",
            cache: false,
        beforeSend: function(){
            $('.ajax-loader').css("visibility", "visible");  
            
        },
        error: function (){ 
            $(".event-tabs-content_js .slick-current.slick-active .events-item_js").html('<div class="padding-3 text-center"><p>No Event</p></div>'); 
            
            $eventContentSlider.slick('setPosition');
            $eventContentSlider.slick("slickSetOption", "adaptiveHeight", true);
         },
        complete: function(){ 
        }, 
        }).done(function (events) {
            // console.log('events: ', events)
             var articleItem = ""
             if (events.length > 0){
                articleItem = events.map(function(item){
                   
                    return '<div class="grid-x events-card align-middle">' + 
                                '<div class="cell small-12 medium-shrink large-shrink events-img">' +
                                    '<img src="'+item.field_event_image+'" class="events img">' +
                                '</div>' +
                                '<div class="cell small-12 medium-auto large-auto events-info">'  + 
                                    '<div class="events-title bordered-right">'  +
                                      '<h2>'+item.title+'</h2>' +
                                    '</div>' + 
                                    '<div class="events-desc">' + 
                                      '<p>' + 
                                      '   تدير الجلسة رئيس تحرير مجلة هي مي بدر <br/>جلسة حوارية مع الرئيس التنفيذي لـ Net a Porter نسرين شقير، الرئيس التنفيذي لـ”فنادق شذا” رقم قرّاش، الرئيس التنفيذي لـ”تسامي” لجين العبيد' + 
                                      '</p> ' + 
                                    '</div>' + 
                                    '<div class="events-date"><i class="icomoon-icon icon-clock"></i><span>'+item.field_event_date+'</span></div>'  +   
                                    '<div class="events-book">'  +
                                        (item.field_buy_online == "" ? "" : '<div class="book-btn"><a href="'+item.field_buy_online+'" class="button">احجز تذكرتك</a></div>'  )+ 
                                    '</div>' + 
                                '</div>' +
                            '</div>'    
                }); 
                  $(".event-tabs-content_js .slick-current.slick-active .events-item_js").html(articleItem);    
            } else{
                $(".event-tabs-content_js .slick-current.slick-active .events-item_js").html('<div class="padding-3 text-center"><p>No Event</p></div>'); 
            } 
  
             
            $eventContentSlider.slick('setPosition');
            $eventContentSlider.slick("slickSetOption", "adaptiveHeight", true);
        }); 
    }
    
    // SLICK
    
    var $tabsSlider = $('.tabs-slider_js');
    $tabsSlider.slick({ 
        slidesToShow: 4, 
        slidesToScroll: 1, 
        dots: false,
        arrows: true, 
        rtl: true,   
        focusOnSelect: true,
        prevArrow: $('.v-prev'),
        nextArrow: $('.v-next'), 
        asNavFor: '.event-tabs-content_js', 
        responsive: [
            {
                breakpoint: 641,
                settings: {
                    swipe: false,
                    slidesToShow: 2 
                }
            },
            
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 6
                }
            }
        ]
    });   
    
    var $eventContentSlider = $('.event-tabs-content_js');
    $eventContentSlider.slick({
        slidesToShow: 1,
        slidesToScroll: 1, 
        dots: false,
        centerMode: false,
        arrows: false,
        focusOnSelect: false,
        rtl: true,
        asNavFor: '.tabs-slider_js',  
    });   
  
  
    $eventContentSlider.on('afterChange', function(event, slick, currentSlide, nextSlide){
        var elSlide = $(slick.$slides[currentSlide]);
        var currentSlideDay = $('.events-slick-item_js', elSlide).data('day');
        var currentSlideMonth = $('.events-slick-item_js', elSlide).data('month');
        
        //console.log(currentSlideDay, currentSlideMonth, "currentSlideDay, currentSlideMonth");
        loadData(currentSlideDay, currentSlideMonth); 
       
    });
  
  
  
    var $tabsSlider = $('.slideshow-show_js');
    $tabsSlider.slick({ 
        slidesToShow: 1, 
        slidesToScroll: 1, 
        dots: false,
        fade: true,
        arrows: true, 
        rtl: true,    
        prevArrow: $('.s-prev'),
        nextArrow: $('.s-next'),  
        responsive: [
            {
                breakpoint: 641,
                settings: {
                   // swipe: false, 
                }
            } 
        ]
    }); 
  
  }
});